import React from 'react';
import { List, ListItem } from '@thd-olt-component-react/list';
import { arrayOf, shape, string, bool } from 'prop-types';
import { DocumentLink } from '../DocumentLink/DocumentLink';
import './document-list.scss';

export const publish = (target) => {
  const eventData = {
    component: 'info-and-guides',
    section: 'product-overview',
    target
  };
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('zone-b.click', eventData);
  }
};

export const DocumentList = ({ documents, returnMessage, showReturnMessage }) => {
  const allDocuments = showReturnMessage && returnMessage !== 'Non-Returnable' ? [...documents, {
    name: 'Return Policy',
    url: 'https://www.homedepot.com/c/Return_Policy'
  }] : documents;

  return (
    <List className="document-list-wrapper">
      {allDocuments.map((document) => {
        const { name, url } = document;
        return (
          <ListItem key={name} onclick={() => { publish(name); }}>
            <DocumentLink name={name} url={url} />
          </ListItem>
        );
      })}
    </List>
  );
};

DocumentList.displayName = 'DocumentList';

DocumentList.propTypes = {
  documents: arrayOf(shape({
    name: string.isRequired,
    url: string.isRequired
  })).isRequired,
  returnMessage: string,
  showReturnMessage: bool
};
DocumentList.defaultProps = {
  returnMessage: '',
  showReturnMessage: false
};
